export default function Logo({ size = 36, className = "" }) {
    return (
        <img
            src="/logo-myecotour.webp"
            srcSet="/logo-myecotour-sm.webp 128w, /logo-myecotour.webp 256w"
            sizes={`${size}px`}
            width={size}
            height={size}
            alt="MyEcoTour — Nature and Adventure"
            className={`rounded-full shrink-0 ${className}`}
            style={{ width: size, height: size, objectFit: "contain" }}
            loading="eager"
            decoding="async"
        />
    );
}
